import React from 'react';
import classnames from 'classnames';

import CheckmarkSVG from '../svg/icons/checkmark.svg';
import DashSVG from '../svg/icons/dash.svg';

const CheckIcon = ({ className }) => (
  <CheckmarkSVG className={classnames('fill-current w-5', className)} />
);

const DashIcon = ({ className }) => (
  <DashSVG className={classnames('w-5 text-pigeon-post', className)} />
);

const PricingFeatureBoolean = ({ included }) =>
  included ? <CheckIcon className="text-shamrock" /> : <DashIcon />;

export default PricingFeatureBoolean;
